import { getCurrentStep } from './helpers'

const Heading = ({ step }) => <h2 className="cc-heading--step">{getCurrentStep(step)}</h2>

export default Heading
